export const LEVEL1 = "Level 1";
export const LEVEL2 = "Level 2";
export const LEVEL3 = "Level 3";
export const LEVEL4 = "Level 4";
export const LEVEL5 = "Level 5";
export const LEVEL6 = "Level 6";
export const LEVEL7 = "Level 7";
